export const BACKEND_URL = "https://staging.api.duneassurances.com";
export const REACT_QUERY_DEVTOOLS = false;
export const ENV: "dev" | "staging" | "production" = "staging";
export const DEFAULT_EMAIL_DOMAIN = "mg.duneassurances.com";
